import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import styles from './saveToExcel.module.css'

const ExcelExport = ({ data, fileName }) => {
    return (
        <div className={styles.save_btn}>
            <button onClick={()=>exportToExcel({data,fileName})}>Export to Excel</button>
        </div>
    );
}

const exportToExcel = ({data,fileName}) => {
    const cap_data = capitalizeDataKeys(data)
    const worksheet = XLSX.utils.json_to_sheet(cap_data);
    worksheet['!cols'] = generateEqualColumnWidth({data:cap_data,width:38})
    worksheet['!rows'] = [{hpt:30}]
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});

    saveAs(blob, `${fileName}.xlsx`);
}

const capitalizeDataKeys = (data)=>{
    const column_keys = Object.keys(data[0])
    const cap_data = data.map((item)=>{
        const new_obj = {}
        column_keys.map((key)=>{
            new_obj[key.toUpperCase()] = item[key]
        })
        return new_obj
    })

    return cap_data
}

const generateEqualColumnWidth = ({data,width})=>{
        // data:[{}]
        if(!data) return []
        const column_keys = Object.keys(data[0])
        if(!column_keys) return []
        return column_keys.map(()=>({wch:width}))
}

// const increaseHeaderHeight = ({data,height})=>{
//     // data:[{}]
//     if(!data) return []
//     const column_keys = Object.keys(data[0])
//     if(!column_keys) return []
//     return column_keys.map(()=>({hpt:height}))
// }

export default ExcelExport;